module.exports = __webpack_public_path__ + "img/avatar.5a37fa50.jpg";